module.exports = __webpack_public_path__ + "static/media/img_6.d80b3b3f.png";